<template>
  <div class="custom-banner-box" style="">
    <div class="custom-banner-box__item">
      <div v-if="bannerList.length === 1">
        <img
            :src="bannerList[0].imageUrl"
            width="100%"
            alt=""
            :style="{ height: swiperHeight }"
            data-is-first="true"
            @load="onImageLoad($event)"
            @click="onBannerClickOnly(0)"
        />
      </div>
      <div v-else id="banner" class="">
        <ol class="custom-banner-box__dots" v-show="isShowDot">
          <li v-for="(item, i) in bannerList" :key="i" ref="bannerDot"
              class="dot" :class="{active: i===0}" @click="changeBanner(i)"></li>
        </ol>
        <!-- Wrapper for slides -->
        <swiper :options="swiperOptions" class="item-wrap" ref="bannerSwiper" :style="{ height: swiperHeight }">
          <swiper-slide v-for="(banner, index) in bannerList" :key="index">
            <img
                :src="banner.imageUrl"
                :class="{'pointer': banner.isPointer}"
                width="100%"
                alt=""
                :data-is-first="index === 0"
                @load="onImageLoad($event, index)"
            />
          </swiper-slide>
        </swiper>
        <a v-if="bannerList.length > 1" class="left carousel-control" @click="goPrev()">
          <span class="banner-arrow-icon banner-arrow-left" aria-hidden="true">
              <img :src="leftArrowImg" alt="" />
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a v-if="bannerList.length > 1" class="right carousel-control" @click="goNext()">
          <span class="banner-arrow-icon banner-arrow-right" aria-hidden="true">
              <img :src="rightArrowImg" alt="" />
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'

export default {
  name: 'CustomBannerSwiper',
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  props: {
    bannerList: {
      type: Array,
      default () {
        return []
      }
    },
    isShowDot: {
      type: Boolean,
      default () {
        return false
      }
    },
    autoplay: {
      type: Boolean,
      default () {
        return false
      }
    },
    delay: {
      type: Number,
      default() {
        return 5000
      }
    },
    leftArrowImg: {
      type: String,
      default () {
        return 'https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/arrow-left.jpg'
      }
    },
    rightArrowImg: {
      type: String,
      default () {
        return 'https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/arrow-right.jpg'
      }
    }
  },
  data () {
    let autoplay = false
    if (this.autoplay) {
      autoplay = {
        delay: this.delay
      }
    }
    return {
      swiperOptions: {
        loop: true,
        speed: 500,
        autoplay: autoplay,
        on: {
          slideChangeTransitionEnd: this.onBannerSliderChange,
          click: this.onBannerClick
        }
      },
      swiper: null,
      swiperHeight: 'auto', // 默认自动高度
      aspectRatio: null, // 存储第一张图片的宽高比（高度/宽度）
      isFirstImageLoaded: false // 标记第一张图片是否已加载
    }
  },
  mounted() {
    if (this.bannerList.length <= 1) {
      this.swiperOptions.loop = false
    }
    // 窗口变化重新计算高度
    window.addEventListener('resize', this.handleResize)
    this.$nextTick(()=> {
      this.onBannerInit()
      // 如果图片已缓存，手动检查
      this.checkFirstImageLoaded()
    })
  },
  methods: {
    goPrev () {
      if (!this.swiper && this.$refs.bannerSwiper) {
        this.swiper = this.$refs.bannerSwiper.$swiper
      }
      this.swiper.slidePrev()
    },
    goNext () {
      if (!this.swiper && this.$refs.bannerSwiper) {
        this.swiper = this.$refs.bannerSwiper.$swiper
      }
      this.swiper.slideNext()
    },
    onBannerInit () {
      if (this.$refs.bannerSwiper) {
        this.swiper = this.$refs.bannerSwiper.$swiper
        if (this.autoplay && this.bannerList.length > 1) {
          this.swiper.autoplay.stop()
          this.swiper.autoplay.start()
        }
      }
    },
    onBannerSliderChange () {
      if (!this.swiper && this.$refs.bannerSwiper) {
        this.swiper = this.$refs.bannerSwiper.$swiper
      }

      if (this.swiper) {
        const index = this.swiper.realIndex
        if (this.isShowDot) {
          const dots = this.$refs.bannerDot
          dots.forEach(dot=> {
            dot.classList.remove('active')
          })
          dots[index].className += ' active'
        }
        // document.getElementById('cruiseDetailBannerIndex').innerHTML = this.swiper.realIndex + 1

        this.$emit('onBannerSliderChange', index)
      }
    },
    changeBanner (index) {
      if (this.swiper) {
        this.swiper.slideTo(index+1)
      }
    },
    onBannerClick () {
      if (this.swiper) {
        const index = this.swiper.realIndex
        this.$emit('on-jump', this.bannerList[index])
      }
    },
    onBannerClickOnly(index) {
      this.$emit('on-jump', this.bannerList[index])
    },

    // 检查第一张图片是否已缓存
    checkFirstImageLoaded() {
      // 通过 data-is-first 精确定位第一张图，不能用 querySelectorAll('img')[0]：
      // Swiper loop 模式会克隆 slide（把最后一张克隆到最前面、第一张克隆到最后），DOM 顺序会被打乱
      const firstImg = this.$el && this.$el.querySelector('img[data-is-first="true"]')
      if (!firstImg) return

      if (firstImg.complete && firstImg.naturalWidth > 0) {
        this.onImageLoad({ target: firstImg })
      }
    },

    onImageLoad(e) {
      const img = e.target
      if (img.getAttribute('data-is-first') !== 'true' || this.isFirstImageLoaded) return
      const imgW = img.naturalWidth
      const imgH = img.naturalHeight

      if (!imgW || !imgH) {
        this.setSwiperHeight(145) // 使用默认高度
        return
      }

      // 保存宽高比（高度/宽度），最终高度 = 容器宽度 × 宽高比
      this.aspectRatio = imgH / imgW
      this.isFirstImageLoaded = true
      // 计算实际高度并设置
      this.calculateAndSetHeight()
    },

    calculateAndSetHeight() {
      if (!this.isFirstImageLoaded || !this.aspectRatio) return

      this.$nextTick(() => {
        // 获取容器实际宽度
        const container = this.$el
        const rect = container.getBoundingClientRect()
        // PC 端 banner 宽度固定 1200px，获取不到容器宽度时回退到 1200
        const containerWidth = rect && rect.width > 0 ? rect.width : 1200

        if (!containerWidth || containerWidth <= 0) return

        // 高度 = 容器宽度 × 图片宽高比
        let finalHeight = containerWidth * this.aspectRatio
        finalHeight = Math.round(finalHeight * 100) / 100
        this.setSwiperHeight(finalHeight)
      })
    },

    setSwiperHeight(height) {
      const rounded = Math.round(height * 100) / 100
      const heightStr = rounded + 'px'

      if (heightStr !== this.swiperHeight) {
        this.swiperHeight = heightStr

        // 更新Swiper
        if (!this.swiper && this.$refs.bannerSwiper) {
          this.swiper = this.$refs.bannerSwiper.$swiper
        }
        if (this.swiper && !this.swiper.destroyed) {
          this.$nextTick(() => {
            this.swiper.update()
          })
        }
      }
    },

    // 窗口变化重新计算
    handleResize() {
      if (this.isFirstImageLoaded) {
        this.calculateAndSetHeight()
      }
    },

  },
  computed: {
    timing () {
      return "timing"
    },
  },
  watch: {
    banners (newValue) {
      if (newValue.length <= 1) {
        this.swiperOptions.loop = false
      } else {
        this.swiperOptions.loop = true
      }
    },
    bannerList: {
      handler(newVal) {
        if (newVal && newVal.length) {
          // 重置状态
          this.aspectRatio = null
          this.isFirstImageLoaded = false
          this.swiperHeight = 'auto'
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="less" scoped>
.custom-banner-box{
  position: relative;
  & .item-wrap {
    width: 100%;
    & .pointer{
      cursor: pointer;
    }
  }
  & .carousel-control {
    width: 10%;
    opacity: 1;
    background: none;
    & .banner-arrow-left {
      left: 50%;
      margin-left: -17px;
    }

    & .banner-arrow-right {
      right: 50%;
      margin-right: -17px;
    }

    & .banner-arrow-icon {
      display: block;
      width: 34px;
      height: 34px;
      margin-top: -17px;
      cursor: pointer;
      position: absolute;
      top: 50%;
      z-index: 0;
      &:active {
        opacity: .8;
      }
      & > img {
        vertical-align: inherit;
      }
    }
  }

  .custom-banner-box__item {
    & img {
      cursor: pointer;
    }
  }

  .custom-banner-box__dots {
    position: absolute;
    bottom: 10px;
    left: 0;
    z-index: 15;
    width: 100%;
    padding: 0;
    margin: 0;
    text-align: center;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0 5px;
    & .dot {
      width: 30px;
      height: 5px;
      cursor: pointer;
      border-radius: 5px;
      background-color: rgb(211, 218, 221);
      opacity: 0.7;
      &.active {
        background-color: #ffcd00;
      }
    }
  }
}


#banner {
  width: 100%;
  position: relative;
  & .carousel-control {
    z-index: 1;
    &.right-special{
      right:150px;
      left: auto;
    }
    &.left-special{
      left:150px;
      right: auto;
    }
  }
}
</style>
